// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf } from "@altostra/type-validations";
import { number } from "@altostra/type-validations/lib/primitives";

export const isChartsContentCardsResult = objectOf({
  daily_content_cards_stats: objectOf({
    sent_count_by_hour: arrayOf(arrayOf(number)),
    impression_count_by_hour: arrayOf(arrayOf(number)),
    unique_impression_count_by_hour: arrayOf(arrayOf(number)),
    click_count_by_hour: arrayOf(arrayOf(number)),
    unique_click_count_by_hour: arrayOf(arrayOf(number)),
    dismiss_count_by_hour: arrayOf(arrayOf(number)),
    unique_dismiss_count_by_hour: arrayOf(arrayOf(number)),
  }),
});
